export const REQUIRED_PLACEHOLDERS = {
  NDB_POINT_ACC_BALANCE_INCREASE_SMS: ['{month}', '{points-earned}', '{total-points}', '{point-account-link}'],
  NDB_POINT_ACC_CREATION_SMS: ['{point-account-link}'],
};

export const PLACEHOLDER_LABELS = {
  '{month}': 'month',
  '{points-earned}': 'points earned',
  '{total-points}': 'total points',
  '{point-account-link}': 'point account link',
};

export const PLACEHOLDER_SAMPLE_VALUES = {
  'month': 'June',
  'points earned': '150',
  'total points': '2,500',
  'point account link': 'https://thyaga.lk/my-account',
};

export const getRequiredPlaceholders = (domainKey) => REQUIRED_PLACEHOLDERS[domainKey] || [];

export const convertTokensToLabels = (value) => {
  let result = value || '';
  Object.entries(PLACEHOLDER_LABELS).forEach(([token, label]) => {
    result = result.split(token).join(label);
  });
  return result;
};

export const convertLabelsToTokens = (value) => {
  let result = value || '';
  Object.entries(PLACEHOLDER_LABELS).forEach(([token, label]) => {
    result = result.split(label).join(token);
  });
  return result;
};

export const getMissingPlaceholders = (displayValue, domainKey) =>
  getRequiredPlaceholders(domainKey).filter(
    (token) => !displayValue.includes(PLACEHOLDER_LABELS[token])
  );

export const getPreviewMessage = (displayValue) => {
  let preview = displayValue || '';
  Object.entries(PLACEHOLDER_SAMPLE_VALUES).forEach(([label, sample]) => {
    preview = preview.split(label).join(sample);
  });
  return preview;
};

export const buildPlaceholderInsertion = (currentValue, start, end, label) => {
  const before = currentValue.slice(0, start);
  const after = currentValue.slice(end);
  const prefix = before.length > 0 && !/\s$/.test(before) ? ' ' : '';
  const suffix = after.length > 0 && !/^\s/.test(after) ? ' ' : '';
  const newValue = before + prefix + label + suffix + after;
  const cursorPos = start + prefix.length + label.length + suffix.length;

  return { newValue, cursorPos };
};

export const removePlaceholderLabel = (currentValue, label) => {
  const idx = currentValue.indexOf(label);
  if (idx === -1) return currentValue;

  let newValue = currentValue.slice(0, idx) + currentValue.slice(idx + label.length);
  if (newValue[idx - 1] === ' ' && newValue[idx] === ' ') {
    newValue = newValue.slice(0, idx) + newValue.slice(idx + 1);
  } else if (idx === 0 && newValue[0] === ' ') {
    newValue = newValue.slice(1);
  } else if (idx === newValue.length && newValue[newValue.length - 1] === ' ') {
    newValue = newValue.slice(0, -1);
  }

  return newValue;
};

export const validateEditForm = (editForm) => {
  const errors = {};

  if (!editForm.value || editForm.value.trim().length === 0) {
    errors.value = 'Template value is required.';
    return { isValid: false, errors };
  }

  const missing = getMissingPlaceholders(editForm.value, editForm.domainKey);
  if (missing.length > 0) {
    const missingLabels = missing.map((token) => PLACEHOLDER_LABELS[token]);
    errors.value = `Missing required field${missing.length > 1 ? 's' : ''}: ${missingLabels.join(', ')}`;
  }

  return { isValid: Object.keys(errors).length === 0, errors };
};
